import { defineStore } from 'pinia'

const NOINDEX = -1;
export const botContext = defineStore('botContext', {
  state: () => {
    return {
      clients : [],
      meetings : [],
      callstate : [],
      containers : [],
      contexts : [],
      commands : [],
      headerIcons : [],
      streams : [],
      attributions : [],
      history : {},
      mediasegments : {},
      recordings : [],
      yjs : [],
      serverinfo : null,
      serverConfig : null,
      settings : {Overlay : true, SmartView : false},
      iceInfo : {},
      clientsettings : {},
      bots : [],
      appInfo : {},
      location : {},
      env : null
    }
  },
  actions: {
    addClient(client) {
      let index = this.clients.findIndex((storeClient) => storeClient.Client == client.Client);
			if(index != NOINDEX) {
				this.clients[index] = client;
			} else {
        this.clients.push(client);
      }
    },
    delClient(client) {
      let index = this.clients.findIndex((storeClient) => storeClient.Client == client.Client);
			if(index != NOINDEX) {
        this.clients.splice(index, 1);
			}
    },
    updateMeetingContext(client, MeetingContext) {
      let index = this.clients.findIndex((storeClient) => storeClient.Client == client.Client);
			if(index != NOINDEX) {
				this.clients[index].MeetingContext = MeetingContext;
        let MeetingJson = JSON.parse(MeetingContext);
        this.clients[index].Meeting = MeetingJson.MeetingId;
      }
    },
    updateDeskContext(client, DeskContext) {
      let index = this.clients.findIndex((storeClient) => storeClient.Client == client.Client);
      if(index != NOINDEX) {
        this.clients[index].DeskContext = DeskContext;
      }
    },
    addToMeeting(member) {
      let index = this.meetings.findIndex((currentMember) => currentMember.MeetingParentID == member.MeetingParentID && currentMember.ClientID == member.ClientID);
      if(index == NOINDEX) {
        this.meetings.push(member);
			}
    },
    delFromMeeting(member) {
      let index = this.meetings.findIndex((currentMember) => currentMember.MeetingParentID == member.MeetingParentID && currentMember.ClientID == member.ClientID);
			if(index != NOINDEX) {
        this.meetings.splice(index, 1);
			}
    },
    setCallState(callstate) {
      let index = this.callstate.findIndex((storeCallState) => storeCallState.ClientID == callstate.ClientID);
      if(index != NOINDEX) {
        this.callstate[index] = callstate;
      } else {
        this.callstate.push(callstate);
      }
    },
    delCallState(callstate) {
      let index = this.callstate.findIndex((storeCallState) => storeCallState.ClientID == callstate.ClientID);
      if(index != NOINDEX) {
        this.callstate.splice(index, 1);
      }
    },
    addContainer(container) {
      let index = this.containers.findIndex((storeContainer) => storeContainer.ContainerID == container.ContainerID);
			if(index != NOINDEX) {
				//this.containers[index] = container;
			} else {
        this.containers.push(container);
      }
    },
    delContainer(container) {
      let index = this.containers.findIndex((storeContainer) => storeContainer.ContainerID == container.ContainerID);
			if(index != NOINDEX) {
        this.containers.splice(index, 1);
			}
    },
    attachShadow(dominfo) {
      let index = this.containers.findIndex((storeContainer) => storeContainer.ContainerID == dominfo.ContainerID);
			if(index != NOINDEX) {
        this.containers[index].DomHandler = dominfo.DomHandler;
			}
    },
    addContext(context) {
      let index = this.contexts.findIndex((storeContext) => storeContext.clientNodeId == context.clientNodeId);
			if(index != NOINDEX) {
				this.contexts[index] = context;
			} else {
        this.contexts.push(context);
      }
    },
    delContext(clientId) {
      let index = this.contexts.findIndex((storeContext) => storeContext.clientNodeId == clientId);
      if(index != NOINDEX) {
        this.contexts.splice(index, 1);
			}
    },
    addCommands(app) {
      let index = this.commands.findIndex((storeApp) => storeApp.appId == app.appId);
			if(index != NOINDEX) {
				this.commands[index] = app;
			} else {
        this.commands.push(app);
      }
    },
    delCommands(app) {
      let index = this.commands.findIndex((storeApp) => storeApp.appId == app.appId);
			if(index != NOINDEX) {
        this.commands.splice(index, 1);
			}
    },
    addHeadderIcon(icon) {
      let index = this.headerIcons.findIndex((storeIcon) => storeIcon.appId == icon.appId);
			if(index != NOINDEX) {
				this.headerIcons[index] = icon;
			} else {
        this.headerIcons.push(icon);
      }
    },
    delHeaderIcon(icon) {
      let index = this.headerIcons.findIndex((storeIcon) => storeIcon.appId == icon.appId);
			if(index != NOINDEX) {
        this.headerIcons.splice(index, 1);
			}
    },
    addStream(Stream) {
      //console.log("Stream => AddEvent", Stream);
      let index = this.streams.findIndex((storeStreams) => storeStreams.MeetingId == Stream.MeetingId && storeStreams.ClientId == Stream.ClientId && storeStreams.MediaType == Stream.MediaType);
			if(index != NOINDEX) {
				this.streams[index] = Stream;
        //console.log("Stream => Updated", Stream);
			} else {
        this.streams.push(Stream);
        //console.log("Stream => Added", Stream);
      }
    },
    delStream(Stream) {
      //console.log("Stream => DelEvent", Stream);
      let index = this.streams.findIndex((storeStreams) => storeStreams.MeetingId == Stream.MeetingId && storeStreams.ClientId == Stream.ClientId && storeStreams.MediaType == Stream.MediaType);
			if(index != NOINDEX) {
        this.streams.splice(index, 1);
			}
    },
    addRecording(recording) {
      let index = this.recordings.findIndex((storeRecording) => storeRecording.ClientId == recording.ClientId && storeRecording.MediaType == recording.MediaType);
			if(index != NOINDEX) {
				this.recordings[index] = recording;
			} else {
        this.recordings.push(recording);
      }
    },
    delRecording(recording) {
      let index = this.recordings.findIndex((storeRecording) => storeRecording.ClientId == recording.ClientId && storeRecording.MediaType == recording.MediaType);
			if(index != NOINDEX) {
				this.recordings.splice(index, 1);
			}
    },
    setAttributions(attributions) {
      this.attributions.push(...attributions);
    },
    setHistory(history) {
      this.history = history;
    },
    addYjs(clientdoc) {
      let index = this.yjs.findIndex((doc) => doc.ClientID == clientdoc.ClientID);
			if(index != NOINDEX) {
				this.yjs[index] = clientdoc;
			} else {
        this.yjs.push(clientdoc);
      }
    },
    setSettings(params) {
      if(params.name && params.value) {
        this.settings[params.name] = params.value;
      }
    },
    setIceInfo(params) {
      if(params.accountSid) {
        this.iceInfo = params;
      }
    },
    setMediaSegments(params) {
      if(params.MeetingParentId) {
        this.mediasegments[params.MeetingParentId] = params;
      }
    },
    addBot(bot) {
      let index = this.bots.findIndex((storeBot) => storeBot.ClientID == bot.ClientID && storeBot.AppID == bot.AppID);
			if(index != NOINDEX) {
				this.bots[index] = bot;
			} else {
        this.bots.push(bot);
      }
    },
    delBot(bot) {
      let index = this.bots.findIndex((storeBot) => storeBot.ClientID == bot.ClientID && storeBot.AppID == bot.AppID);
			if(index != NOINDEX) {
        this.bots.splice(index, 1);
			}
    },
  },
  getters: {
    getDomByContainer : (state) => {
      return (ContainerID) => state.containers.find((storeContainer) => storeContainer.ContainerID == ContainerID);
    },
    getClientByID : (state) => {
      return (ClientID) => state.clients.find((storeClient) => storeClient.Client == ClientID);
    },
    getClientByViewPort : (state) => {
      return (ViewPortID) => state.clients.find((storeClient) => window.devStore.viewPorts.find((viewport) => viewport.viewportID == ViewPortID && storeClient.Client == viewport.ClientID));
    },
    getClientByMeeting : (state) => {
      return (MeetingID) => state.clients.find((storeClient) => storeClient.Meeting == MeetingID);
    },
    getAccountByType : (state) => {
      return (accountType) => state.attributions.find((atrribution) => atrribution.AccountType == accountType);
    },
    getAccountByGatewayPE : (state) => {
      return (GatewayPE) => state.attributions.find((atrribution) => atrribution.GatewayPE == GatewayPE);
    },
    getMembers : (state) => {
      return (MeetingID) => state.meetings.filter((member) => member.MeetingParentID == MeetingID);
    },
    // getParticipantByClientID : (state) => {
    //   return (ClientID) => state.meetings.find((participant) => participant.Client == ClientID);
    // },
    getMediaStreams : (state) => {
      return (MeetingId) => state.streams.filter(stream => stream.MeetingId == MeetingId);
    },
    getStreamTypeByClient : (state) => {
      return (ClientId, MediaType) => state.streams.find(stream => stream.ClientId == ClientId && stream.MediaType == MediaType);
    },
    verifyStream : (state) => {
      return (vstream) => state.streams.findIndex(stream => stream.MeetingId == vstream.MeetingId && stream.ClientId == vstream.ClientId && stream.MediaType == vstream.MediaType);
    },
    getMediaSegments : (state) => {
      return (MeetingParentId) => state.mediasegments[MeetingParentId];
    },
    getRecording : (state) => {
      return (ClientId, MediaType) => state.recordings.find((recording) => recording.ClientId == ClientId && recording.MediaType == MediaType);
    },
    getBot : (state) => {
      return (ClientID, AppID) => state.bots.find((bot) => bot.ClientID == ClientID && bot.AppID == AppID);
    },
    getEnv : (state) => {
      return state.env;
    },
    getCallState : (state) => {
      return (ClientID) => state.callstate.find((callstate) => callstate.ClientID == ClientID);
    }
  }
})
